import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';

interface IProps {
  customerId: string;
}
export interface IGustoLinkTokenResponse {
  url: string;
  state: string;
}
export const useGenerateGustoLinkToken = ({ customerId }:IProps, onSuccess: (response: IGustoLinkTokenResponse) => void, onError: (error: IServerErrorResponse) => void) => useQuery(
  ['generateGustoLinkToken', customerId],
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/v1/user/${customerId}/payroll/linkToken`));
    return data;
  },
  {
    enabled: false,
    retry: 0,
    onSuccess: (response: IGustoLinkTokenResponse) => {
      if (onSuccess) onSuccess(response);
    },
    onError: (error: IServerErrorResponse) => {
      if (onError) onError(error);
    },
  },
);
